export default "__VITE_ASSET__BZSkdnwD__"